<div class="body ui container" fxLayout="column">

        <div fxLayout="row" fxLayoutAlign='space-between center' class="top">

             <div>
                    <span>Home</span>
                      <h2 class="ui primary header">Frequently Asked Questions</h2>
             </div>

        </div>
        <div class="ui divider" appMargin marginY="3"></div>
            <app-faq-row *ngFor="let faq of faqs"
                [faq]="faq">
            </app-faq-row>

